import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { useDonorContext } from '@/context'
import { ROUTES } from '@/constants'
import { isEmpty } from '@/utils'

export const Footer = () => {
  const { donor } = useDonorContext()
  const isLoggedIn = donor && !isEmpty(donor)

  return (
    <Box
      component='footer'
      sx={{ borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper' }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.25,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          color: 'text.secondary',
        }}
      >
        <Typography variant='caption'>Forcyte Scheduling Platform</Typography>
        <Typography variant='caption'>
          © BBCS 2025 All Rights Reserved
        </Typography>
        {isLoggedIn ? (
          <Typography variant='caption'>Version Forcyte 1.0</Typography>
        ) : (
          <Typography
            component={Link}
            to={ROUTES.CHAIRPERSON_LOGIN}
            variant='caption'
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Chairperson Login
          </Typography>
        )}
      </Box>
    </Box>
  )
}
